import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/deals/[id]/estimations/edit/Page";

export const PATH = (id: number): string =>
	`/vendors/deals/${id}/estimations/edit`;

function Estimations() {
	return (
		<>
			<NskHead title="見積り作成" />
			<Component />
		</>
	);
}

export default Estimations;
